<template>
  <v-dialog
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="950"
    open-delay="300"
  >
    <v-card class="thank-you-modal rounded-xl">
      <v-card-text class="text-center py-22">
        <inline-svg style="width: 170px" src="/img/plus/done_icon.svg" />

        <h2 class="mt-6 mb-2 font-weight-bold white--text thank-you-text">
          Thank You
        </h2>
        <p class="white--text thank-you-caption">
          Your IQ Plus subscription is now active.<br />
          Enjoy your new features and start scaling smarter.
        </p>

        <v-btn
          outlined
          color="white"
          class="mt-6 px-20 font-size-h6 py-5 rounded-lg cursor-pointer"
          @click="goToDashboard"
        >
          Back To Dashboard
        </v-btn>
      </v-card-text>

      <v-btn icon class="thank-you-close" @click="dialog = false">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false, // set true to show immediately
    };
  },
  methods: {
    toggleModal() {
      this.dialog = !this.dialog;
    },
    goToDashboard() {
      this.$router.push({ name: "dashboard.dashboardDelivery" });
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.thank-you-modal {
  background: linear-gradient(90deg, #4a6cf7 0%, #8e2de2 100%);
  /* border-radius: 20px; */
  position: relative;
}

.thank-you-close {
  position: absolute;
  top: 10px;
  right: 10px;
}
.thank-you-text {
  font-size: 60px;
}
.thank-you-caption {
  font-size: 21px;
  line-height: 29px;
}
</style>
